import LocationView from './LocationView'

export default LocationView
